import { useEffect } from "react";
import { useTerminaltore } from '../../store/TerminaisStores';
import { Box, Paper, Typography } from "@mui/material";

import CardsErrosImpressao from '../../components/TabelaErroImpressao'

export default function ImpressaaoPage() {


    const {
        BuscarErrosDeImpressao,
        errosDeImpressao,
        carregando,
        deletingId,
        ResolverErrosDeImpressao
    } = useTerminaltore();

    useEffect(() => {
        async function fetchDados() {
            await BuscarErrosDeImpressao();
        }

        fetchDados();
        const intervalId = setInterval(fetchDados, 10000);
        return () => clearInterval(intervalId);
    }, []);


    async function HandleResolverProblema(id) {
        await ResolverErrosDeImpressao(id);
    }

    return (

        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '99%', backgroundColor: 'transparent' }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de erros
            </Typography>

            <Box sx={{ mt: 4 }}>
                <CardsErrosImpressao
                    erros={errosDeImpressao}
                    onResolve={HandleResolverProblema}
                    loadingState={{ carregando, deletingId }}
                />
            </Box>
        </Paper>
    )
}